module.exports = __webpack_public_path__ + "img/xunjianqingdan.17647f1d.svg";